import script from "./user_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./user_detail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__